import { useApi } from "@appretio/api";
import { useQuery } from "@tanstack/react-query";
import { forecastVersionsQueryKeys } from "./queryKeys";

/**
 * Fetches all forecast versions
 */
export function useFetchVersions(enabled: boolean = true) {
  const apiClient = useApi();

  return useQuery({
    queryKey: forecastVersionsQueryKeys.data(),
    meta: {
      errorMessage: "Failed to fetch forecast versions"
    },
    queryFn: async () => {
      const response = await apiClient.GET("/v2/forecast/cubes/versions");

      return (
        response.data?.result ?? {
          user_versions: [],
          other_user_versions: [],
          ds_versions: []
        }
      );
    },
    enabled,
    staleTime: Infinity
  });
}
